import { Button } from '@/common/ui'
import { REWARDS_COPY } from '@/locales/en'

type Props = {
    onBackToDashboard: () => void
}

export function RewardsEmptyState({ onBackToDashboard }: Props) {
    return (
        <>
            <div className="justify-center text-black text-xs font-normal font-['Inter'] leading-5">
                {REWARDS_COPY.noRewards}
            </div>

            <Button
                className="mt-10 flex flex-col justify-start items-start"
                variant="secondary"
                onClick={onBackToDashboard}
            >
                <div className="justify-start text-content-primary text-sm font-medium font-['Inter'] leading-tight">
                    {REWARDS_COPY.noRewardsButton}
                </div>
            </Button>
        </>
    )
}
